import { Helmet } from "react-helmet-async";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQJsonLdProps {
  faqs: FAQItem[];
}

/**
 * FAQPage structured data for LLM citations and rich snippets.
 * LLMs heavily rely on FAQ schema for direct answer extraction.
 * Only renders if FAQ content exists (conditional rendering).
 */
export function FAQJsonLd({ faqs }: FAQJsonLdProps) {
  // Conditional rendering: only show schema if FAQs exist
  if (!faqs || faqs.length === 0) {
    return null;
  }

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>
  );
}
